import { ftClockCalendarFromArr, ftClockColsFromArr, ftFormatCampaignTime, type CampaignClockFormatted } from './campaign-clock';

/** Raw campaign adoption precedes every display/countdown reader, including a paused clock. */
export function ftInstallCampaignClockDisplay(campaign: unknown, formatted?: CampaignClockFormatted): CampaignClockFormatted | null {
    if (!campaign || typeof campaign !== 'object') return null;
    const arr = campaign as { computed?: { campaign?: Record<string, unknown> } };
    const f = formatted ?? ftFormatCampaignTime(ftClockColsFromArr(campaign), ftClockCalendarFromArr(campaign));
    const cc = ((arr.computed ??= {}).campaign ??= {});
    cc.calendar_current_date_f = f.calendar_current_date_f;
    cc.calendar_current_time_f = f.calendar_current_time_f;
    cc.calendar_current_full_date_f = f.calendar_current_full_date_f;
    cc.calendar_current_full_date_named_f = f.calendar_current_full_date_named_f;
    cc.campaign_now_seconds = f.campaign_now_seconds;
    return f;
}

/** A public campaign card carries its small raw clock seed; it needs neither a fetch nor a timer. */
export function ftMountCampaignClockDisplay(root: ParentNode): void {
    root.querySelectorAll<HTMLElement>('[data-ft-campaign-clock]').forEach(element => {
        const formatted = ftInstallCampaignClockDisplay(JSON.parse(element.dataset.ftCampaignClock ?? '{}'));
        if (formatted) element.textContent = formatted.calendar_current_full_date_named_f;
    });
}
